import { keys } from "@menu/core/constants";
import { CachedItem } from "@lib-shared/lib";
import environment from "@menu-environment";

type Inbox = {
    display: boolean,
    unread: number,
    url: string
}
const selfServiceUrl = environment.menu.urls.selfService;
const defaultCulture = environment.menu.defaultCulture;

const defaultInboxUrl = !!selfServiceUrl
    ? `${selfServiceUrl}#/inbox`.replace("{culture}", defaultCulture)
    : "";

export const defaultInbox = {
    display: false,
    unread: 0,
    url: defaultInboxUrl
}

export const sampleInbox = {
    display: true,
    unread: 10,
    url: "#"
}

export const inboxCache = CachedItem.withoutPrefix(keys.inboxData);

export default Inbox;
